import PageHeader from '../components/common/PageHeader';
import MetricCard from '../components/dashboard/MetricCard';
import RecentActivity from '../components/dashboard/RecentActivity';
import { useKeyMetrics } from '../hooks/useDashboard';

export default function ConsoleDashboardPage() {
  const { data, isLoading, isError } = useKeyMetrics();

  return (
    <div>
      <PageHeader title="Dashboard" />

      <section aria-labelledby="key-metrics-heading">
        <h2
          id="key-metrics-heading"
          className="mb-4 text-[18px] font-semibold leading-[27px] text-gray-800 dark:text-gray-100"
        >
          Key Metrics
        </h2>

        {isLoading ? (
          <div className="flex justify-center py-8">
            <div
              role="status"
              aria-label="Loading key metrics"
              className="animate-spin rounded-full h-5 w-5 border-2 border-blue-500 border-t-transparent"
            />
          </div>
        ) : isError || !data ? (
          <p className="text-red-500 dark:text-red-400">Failed to load key metrics</p>
        ) : (
          <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 xl:grid-cols-4">
            <MetricCard label="Lenders" value={data.lenders.count} caption="Active lender accounts setup" />
            <MetricCard
              label={`Orders (${data.windowDays} days)`}
              value={data.orders.count}
              caption={`Orders created in the last ${data.windowDays} days`}
              comparison={{ previous: data.orders.previousCount, period: `previous ${data.windowDays} days` }}
            />
            {data.loans && (
              <MetricCard
                label={`Loans (${data.windowDays} days)`}
                value={data.loans.count}
                caption={`Loans created in the last ${data.windowDays} days`}
                comparison={{ previous: data.loans.previousCount, period: `previous ${data.windowDays} days` }}
              />
            )}
          </div>
        )}
      </section>

      <div className="mt-8">
        <RecentActivity />
      </div>
    </div>
  );
}
